var map = {
	"./en.json": [
		1682,
		63
	],
	"./et.json": [
		1683,
		62
	],
	"./fi.json": [
		1684,
		61
	],
	"./lv.json": [
		1685,
		60
	],
	"./pl.json": [
		1686,
		59
	],
	"./ru.json": [
		1687,
		58
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1679;


//////////////////
// WEBPACK FOOTER
// ./src/i18n lazy ^\.\/.*\.json$
// module id = 1679
// module chunks = 65